/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PunchType = {
    NUMBER_0: 0,
    NUMBER_10: 10,
    NUMBER_100: 100,
    NUMBER_110: 110,
    NUMBER_120: 120,
    NUMBER_130: 130,
    NUMBER_140: 140,
    NUMBER_202: 202,
    NUMBER_255: 255
} as const;

export type PunchType = typeof PunchType[keyof typeof PunchType];



